/**
 * Component Registry for Cowles Landing
 * 
 * Inherits from @vibesites-amc-preferred-theme/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc-preferred-theme/theme-preferred/registry';
import { AmenitiesList } from './components/AmenitiesList';
import { Hero } from './components/Hero';
import { PropertyOverview } from './components/PropertyOverview';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  Hero,
  PropertyOverview,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
